import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { bestGuessAtAppName22d8w4clezb4c as bestGuessAtAppName } from './metadata.js.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { lazyContextAddon10t74vogc7n59 as lazyContextAddon } from './ViewContextExtensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_appName(_this__u8e3s4, _set____db54di) {
  _init_properties_metadata_kt__dcctrj();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_appName_$ref_4h2z78();
  return appName$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('appName', 1, tmp, tmp_0, _set_appName_$ref_ptb74o()), _set____db54di);
}
function get_appName(_this__u8e3s4) {
  _init_properties_metadata_kt__dcctrj();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_appName_$ref_4h2z78();
  return appName$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('appName', 1, tmp, tmp_0, _set_appName_$ref_ptb74o()));
}
var appName$delegate;
function appName$delegate$lambda(it) {
  _init_properties_metadata_kt__dcctrj();
  return bestGuessAtAppName(it);
}
function _get_appName_$ref_4h2z78() {
  return constructCallableReference((p0) => get_appName(p0), 1, 0, 130);
}
function _set_appName_$ref_ptb74o() {
  return constructCallableReference((p0, p1) => {
    set_appName(p0, p1);
    return Unit_instance;
  }, 2, 0, 131);
}
var properties_initialized_metadata_kt_om2s7j;
function _init_properties_metadata_kt__dcctrj() {
  if (!properties_initialized_metadata_kt_om2s7j) {
    properties_initialized_metadata_kt_om2s7j = true;
    appName$delegate = lazyContextAddon(appName$delegate$lambda);
  }
}
//region block: exports
export {
  get_appName as get_appName2d6x7t0626kwl,
};
//endregion

//# sourceMappingURL=metadata.mjs.map
